import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

interface Microservice {
  name: string;
  url: string;
  respFlag?: boolean;
  status: string;
}

@Component({
  selector: 'app-health-check',
  templateUrl: './health-check.component.html',
  styleUrls: ['./health-check.component.scss']
,
  standalone: false
})
export class HealthCheckComponent implements OnInit {

//   microservices: Microservice[] = [
//     { name: 'Portal Proxy Backend', url: 'https://portal.pro-vigil.info/api/health', status: '' },
//     { name: 'Galaxy Backend', url: 'https://galaxy.pro-vigil.info:8443/galaxy/manage/health', status: '' },
//     { name: 'User Activity', url: 'http://user-activity.pro-vigil.info:8080/useractivity/api/health-check', status: '' },
//     { name: 'PV Auth', url: 'https://apps.pro-vigil.info:9052/api/health', status: '' },
//     { name: 'Customer communications', url: 'https://square-prod.pro-vigil.com:6060/health2', status: '' },
//     { name: 'Event Data API', url: 'http://apps.pro-vigil.info:8089/api/health', status: '' },
//     { name: 'Event Processor', url: 'https://apps.pro-vigil.info:8096/api/health', status: '' },
//     { name: 'PV Admin API', url: 'https://pro-fit.pro-vigil.com/api/health', status: '' },
//     { name: 'Profit Snaps', url: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=761754CAM1724792398&withmd=true&station=recordingStation36&farm=8456', status: '', respFlag: true },
//     { name: 'Profit Snap Manager', url: 'https://pro-fit-farms.pro-vigil.info:8442/api/snap/manager/health', status: '' },
//     { name: 'Profit Archive', url: 'https://pro-fit-farms.pro-vigil.info:442/api/health', status: '' }
//     // Add other microservices here
//   ];

  microservices: Microservice[] = [
    { name: 'Portal Proxy Backend', url: 'https://portal.pro-vigil.info/api/health', status: '' },
    { name: 'Galaxy Backend', url: 'https://galaxy.pro-vigil.info:8443/galaxy/manage/health', status: '' },
    { name: 'User Activity', url: 'http://user-activity.pro-vigil.info:8080/useractivity/api/health-check', status: '', respFlag: true },
    { name: 'PV Auth', url: 'http://apps.pro-vigil.info:7052/api/health', status: '' },
    { name: 'Customer communications', url: 'https://square-prod.pro-vigil.com:6060/health2', status: '', respFlag: true },
    { name: 'Event Data API', url: 'http://apps.pro-vigil.info:7089/api/health ', status: '' },
    { name: 'Event Processor', url: 'http://apps.pro-vigil.info:7096/api/health', status: '' },
    { name: 'Media pipeline', url: 'http://apps.pro-vigil.info:7099/api/health', status: '' },
    { name: 'PV Admin API', url: 'https://pro-fit.pro-vigil.com/api/health', status: '' },
    { name: 'Profit Snaps', url: 'https://pro-fit-snaps.pro-vigil.info/api/SnapShot?channel=761754CAM1724792398&withmd=true&station=recordingStation36&farm=8456', status: '', respFlag: true },
    { name: 'Profit Snap Manager', url: 'https://pro-fit-farms.pro-vigil.info:8442/api/snap/manager/health', status: '' },
    { name: 'Profit Archive', url: 'https://pro-fit-farms.pro-vigil.info:442/api/health', status: '' }
    // Add other microservices here
  ];
//   { name: 'Service 1', url: '/health/service1', status: 'healthy' },
//   { name: 'Service 2', url: '/health/service2', status: 'unhealthy' },
//   { name: 'Service 3', url: '/health/service2', status: 'healthy' },
//   { name: 'Service 4', url: '/health/service2', status: 'unhealthy' },

  displayedColumns: string[] = ['name', 'status'];

  constructor(private http: HttpClient) {}

  ngOnInit() {
    this.checkHealth();
  }

  checkHealth() {
    this.microservices.forEach((service, index) => {
        if (service?.respFlag) {
            this.http
              .get(service.url)
              .subscribe(() => {
                this.microservices[index].status = 'healthy';
            });

            this.http.get(service.url, { responseType: 'blob' }).subscribe(
                response => {
                    //debugger;
                  if (response) {
                    this.microservices[index].status = 'healthy';
                  }
                },
                (error: HttpErrorResponse) => {
                    this.microservices[index].status= `unhealthy`;
                }
              );
        } else {
            this.http
              .get(service.url)
              .pipe(
                map(() => 'healthy'),
                catchError(() => of('unhealthy'))
              )
              .subscribe((status) => {
                this.microservices[index].status = status;
            });
        }
      });
  }
}
